import { AttachmentsView } from "./AttachmentsView";

export const DEFAULT_STAGES = ["Scouting", "LOI", "Lease Signed", "Build-out", "Open"];
const LEGACY = { scouting: "Scouting", loi: "LOI", lease_signed: "Lease Signed", build_out: "Build-out", open: "Open" };

export const stagesOf = (e) => (e.stages?.length ? e.stages : DEFAULT_STAGES);
export const stageLabel = (e) => LEGACY[e.stage] || e.stage;

const fmtDate = (d) => {
  if (!d) return "";
  const [y, m] = d.split("-");
  return new Date(+y, +m - 1, 1).toLocaleDateString("en-US", { month: "short", year: "numeric" });
};

function StageTrack({ e }) {
  const stages = stagesOf(e);
  const cur = Math.max(0, stages.indexOf(stageLabel(e)));
  return (
    <div className="mt-5" data-testid="expansion-stage-track">
      <div className="relative flex justify-between">
        <div className="absolute left-0 right-0 top-[7px] h-px bg-brand-border" />
        <div className="absolute left-0 top-[7px] h-px bg-brand-primary transition-all" style={{ width: `${stages.length > 1 ? (cur / (stages.length - 1)) * 100 : 100}%` }} />
        {stages.map((label, i) => (
          <div key={i} className="relative flex flex-col items-center w-0" data-testid={`expansion-stage-step-${i}`}>
            <span className={`h-[15px] w-[15px] rounded-full border-2 ${i < cur ? "bg-brand-primary border-brand-primary" : i === cur ? "bg-brand-page border-brand-primary ring-4 ring-brand-primary/15" : "bg-brand-page border-brand-border"}`} />
            <span className={`mt-2 text-[10px] uppercase tracking-[0.1em] whitespace-nowrap ${i === cur ? "text-brand-primary font-medium" : `hidden sm:block ${i < cur ? "text-brand-ink" : "text-brand-tertiary"}`}`}>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ExpansionView({ items = [] }) {
  const valid = items.filter((e) => (e.name || "").trim() || (e.notes || "").trim() || (e.attachments || []).length);
  if (!valid.length) return null;
  return (
    <section className="mb-14" data-testid="report-expansion-view">
      <h2 className="font-serif text-3xl font-light text-brand-ink mb-6">Expansion</h2>
      <div className="space-y-6">
        {valid.map((e, i) => (
          <div key={i} className="border border-brand-border bg-brand-surface p-6 sm:px-8" data-testid={`report-expansion-${i}`}>
            <div className="flex flex-wrap items-baseline justify-between gap-2">
              <p className="font-serif text-2xl text-brand-ink">{e.name || "Untitled project"}</p>
              {e.target_date && <p className="text-[11px] uppercase tracking-[0.15em] text-brand-gold">Target open · {fmtDate(e.target_date)}</p>}
            </div>
            <div className="px-6 sm:px-8 pb-2"><StageTrack e={e} /></div>
            {e.notes && <p className="text-sm text-brand-muted leading-relaxed mt-6 whitespace-pre-line">{e.notes}</p>}
            <AttachmentsView items={e.attachments} />
          </div>
        ))}
      </div>
    </section>
  );
}
